// src/Step1ProgramType.jsx
import React from 'react';

const PLAN_OPTIONS = [
  {
    requestedPlan: 1,
    title: 'برنامه تمرینی',
    subtitle: 'مناسب وقتی که فقط روی تمرین شخصی‌سازی‌شده تمرکز داری.',
  },
  {
    requestedPlan: 2,
    title: 'برنامه رژیم و تغذیه',
    subtitle: 'مناسب وقتی که فعلاً فقط رژیم غذایی اختصاصی می‌خواهی.',
  },
  {
    requestedPlan: 3,
    title: 'برنامه تمرین و رژیم غذایی',
    subtitle: 'کامل‌ترین انتخاب برای گرفتن نتیجه بهتر و هماهنگ‌تر.',
  },
];
export default function Step1ProgramType({
  form,
  colors,
  priceMap,
  campaignPrice,
  selectJourneyMode,
  selectRequestedPlan,
}) {
  return (
    <div>
      <SelectionHeader
        colors={colors}
        title="چطور می‌خوای شروع کنی؟"
        subtitle="اول مسیر شروع را انتخاب کن، بعد نوع برنامه‌ای که می‌خوای ساخته بشه."
      />

      <div className="grid md:grid-cols-2 gap-4 mb-7">
        <JourneyCard
          active={form.journeyMode === 'full'}
          badge="شروع مستقیم"
          title="برنامه کامل می‌خوام"
          description="مستقیم وارد مسیر ساخت و دریافت برنامه کامل می‌شی."
          meta="برای وقتی که تصمیم‌ات مشخصه"
          icon="⚡"
          onClick={() => selectJourneyMode('full')}
          colors={colors}
        />

        <JourneyCard
          active={form.journeyMode === 'sample'}
          badge="اول پیش‌نمایش"
          title="اول نمونه رو ببینم"
          description="اول یک نمونه از سبک برنامه‌ات می‌بینی و بعد تصمیم می‌گیری."
          meta="برای وقتی که هنوز مردد هستی"
          icon="👀"
          onClick={() => selectJourneyMode('sample')}
          colors={colors}
        />
      </div>

      <SelectionHeader
        colors={colors}
        eyebrow="انتخاب اجباری"
        title="کدوم نوع برنامه برای تو بهتره؟"
        subtitle={
          form.journeyMode === 'sample'
            ? 'همین پلن به‌صورت نمونه بهت نمایش داده می‌شه.'
            : form.journeyMode === 'full'
            ? 'برنامه کامل دقیقاً بر اساس همین انتخاب ساخته می‌شه.'
            : 'بعد از انتخاب مسیر شروع، یکی از پلن‌ها را انتخاب کن.'
        }
      />

      <div className="grid lg:grid-cols-3 gap-4">
        {PLAN_OPTIONS.map((item) => {
          const price = getRequestedPlanPrice(
            item.requestedPlan,
            priceMap,
            campaignPrice
          );

          return (
            <PlanChoiceCard
              key={item.requestedPlan}
              title={item.title}
              subtitle={item.subtitle}
              price={price}
              active={Number(form.requestedPlan) === item.requestedPlan}
              isRecommended={item.requestedPlan === 3}
              onClick={() => selectRequestedPlan(item.requestedPlan)}
              colors={colors}
            />
          );
        })}
      </div>

      {form.journeyMode === 'sample' && (
        <div
          className="mt-4 rounded-2xl border px-4 py-3 text-sm leading-7"
          style={{
            borderColor: colors.border,
            backgroundColor: 'rgba(124,58,237,0.08)',
            color: colors.sub,
          }}
        >
          قیمت‌های بالا مربوط به نسخه کامل برنامه هستند. مشاهده نمونه بدون پرداخت اولیه انجام می‌شود.
        </div>
      )}
    </div>
  );
}

function SelectionHeader({ eyebrow, title, subtitle, colors }) {
  return (
    <div
      className="mb-4 rounded-2xl border p-4"
      style={{
        borderColor: colors.border,
        backgroundColor: 'rgba(255,255,255,0.03)',
      }}
    >
      {eyebrow && (
        <div className="text-xs font-bold mb-2 text-blue-300">
          {eyebrow}
        </div>
      )}

      <h3 className="text-lg md:text-xl font-black mb-2">
        {title}
      </h3>

      <p className="text-sm leading-7" style={{ color: colors.sub }}>
        {subtitle}
      </p>
    </div>
  );
}

function JourneyCard({
  active,
  badge,
  title,
  description,
  meta,
  icon,
  onClick,
  colors,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full text-right rounded-[24px] border p-5 transition hover:scale-[1.01]"
      style={{
        borderColor: active ? '#3b82f6' : colors.border,
        backgroundColor: active ? 'rgba(37,99,235,0.16)' : colors.inputBg,
        boxShadow: active ? '0 18px 40px rgba(37,99,235,0.18)' : 'none',
      }}
    >
      <div className="flex items-start gap-4">
        <div
          className="w-12 h-12 rounded-2xl flex items-center justify-center text-2xl shrink-0"
          style={{
            backgroundColor: active
              ? 'rgba(255,255,255,0.14)'
              : 'rgba(255,255,255,0.05)',
          }}
        >
          {icon}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-3 mb-3">
            <span
              className="rounded-full px-3 py-1 text-xs font-bold"
              style={{
                backgroundColor: active
                  ? 'rgba(147,197,253,0.14)'
                  : 'rgba(255,255,255,0.05)',
                color: active ? '#bfdbfe' : colors.sub,
              }}
            >
              {badge}
            </span>

            <span
              className="w-6 h-6 rounded-full border flex items-center justify-center text-xs"
              style={{
                borderColor: active ? '#60a5fa' : colors.border,
                backgroundColor: active ? '#2563eb' : 'transparent',
                color: '#fff',
              }}
            >
              {active ? '✓' : ''}
            </span>
          </div>

          <h4 className="font-black text-base mb-2">
            {title}
          </h4>

          <p className="text-sm leading-7 mb-3" style={{ color: colors.sub }}>
            {description}
          </p>

          <div className="text-xs font-bold" style={{ color: active ? '#bfdbfe' : colors.muted }}>
            {meta}
          </div>
        </div>
      </div>
    </button>
  );
}

function PlanChoiceCard({
  title,
  subtitle,
  price,
  active,
  isRecommended,
  onClick,
  colors,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full text-right rounded-[24px] border p-5 transition hover:scale-[1.01]"
      style={{
        borderColor: active ? '#3b82f6' : colors.border,
        backgroundColor: active ? 'rgba(37,99,235,0.16)' : colors.inputBg,
        boxShadow: active ? '0 18px 40px rgba(37,99,235,0.18)' : 'none',
      }}
    >
      <div className="flex items-center justify-between gap-3 mb-3">
        {isRecommended ? (
          <span className="rounded-full px-3 py-1 text-xs font-bold bg-purple-500/15 text-purple-300">
            پیشنهاد برای نتیجه بهتر
          </span>
        ) : (
          <span />
        )}

        <span
          className="w-6 h-6 rounded-full border flex items-center justify-center text-xs"
          style={{
            borderColor: active ? '#60a5fa' : colors.border,
            backgroundColor: active ? '#2563eb' : 'transparent',
            color: '#fff',
          }}
        >
          {active ? '✓' : ''}
        </span>
      </div>

      <h4 className="font-black text-base mb-2">
        {title}
      </h4>

      <p className="text-sm leading-7 mb-4" style={{ color: colors.sub }}>
        {subtitle}
      </p>

      <div className="rounded-2xl border px-4 py-3" style={{ borderColor: colors.border }}>
        <div className="font-black text-purple-300">
          {formatTomanFa(price)}
        </div>
        <div className="text-xs mt-1" style={{ color: colors.muted }}>
          نسخه کامل
        </div>
      </div>

      <div className="mt-3 text-xs font-bold" style={{ color: active ? '#93c5fd' : colors.muted }}>
        {active ? 'این پلن انتخاب شده' : 'برای انتخاب، روی این کارت بزن'}
      </div>
    </button>
  );
}

function getRequestedPlanPrice(requestedPlan, priceMap, campaignPrice = 0) {
  const plan = Number(requestedPlan);

  if (plan === 3 && Number(campaignPrice) > 0) {
    return Number(campaignPrice);
  }

  const normal = priceMap?.normal ?? priceMap ?? null;

  switch (plan) {
    case 1:
      return extractNumericPrice(normal?.workout);
    case 2:
      return extractNumericPrice(normal?.diet);
    case 3:
      return extractNumericPrice(normal?.full);
    default:
      return 0;
  }
}

function extractNumericPrice(priceItem) {
  if (priceItem == null) return 0;
  if (typeof priceItem === 'number') return Number(priceItem);
  if (typeof priceItem === 'object') return Number(priceItem.price ?? 0);
  return 0;
}

function formatTomanFa(n) {
  return `${Number(n || 0).toLocaleString('fa-IR')} تومان`;
}